import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import ar from './locales/ar.json';

const resources = {
  en: { translation: en },
  ar: { translation: ar },
};

const LANGUAGE_KEY = 'user-language';

const languageDetector = {
  type: 'languageDetector',
  async: true,
  detect: (callback) => {
    try {
      const stored = localStorage.getItem(LANGUAGE_KEY);
      if (stored) return callback(stored);
      // default to Arabic
      return callback('ar');
    } catch (e) {
      console.warn('i18n detect error', e);
      return callback('ar');
    }
  },
  init: () => {},
  cacheUserLanguage: (lng) => {
    try {
      localStorage.setItem(LANGUAGE_KEY, lng);
      // For web, we don't force reload for RTL; components should honor CSS direction
    } catch (e) {
      console.warn('i18n cache error', e);
    }
  },
};

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ar',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
